import { AllocationMethodologyTitle } from "features/investments/AllocationMethodologyTitle";
import {
  InvestmentLocationFormToggle,
  RealEstateInvestmentTypeFormSelect,
} from "features/investments/InvestmentForm";
import React from "react";
import { useTranslation } from "react-i18next";
import { FormBooleanToggleButtonGroup } from "shared/components/button/ToggleButton";
import { FormDateInput } from "shared/components/input/date/DateInput";
import { FormMoneyInput } from "shared/components/input/text/MoneyInput";
import { FormTextArea } from "shared/components/input/text/TextArea";
import { FormTextInput } from "shared/components/input/text/TextInput";

export const PortfolioFormRequiredFields: React.FC = () => {
  const { t } = useTranslation(["investment", "entity", "common"]);
  return (
    <>
      <FormTextInput
        name="legal_name"
        title={t("investment:portfolioName.full")}
      />
      <FormTextInput
        name="short_name"
        title={t("common:optional", {
          field_name: t("investment:portfolioName.short"),
        })}
      />
      <FormTextInput name="external_id" title={t("entity:externalId")} />
      <FormTextArea
        name="metadata.description"
        title={t("investment:portfolioDescription")}
      />
      <PortfolioAllocationMethodologyFormToggle />
    </>
  );
};

export const PortfolioFormAdditionalFields: React.FC = () => {
  const { t } = useTranslation(["investment", "entity"]);
  return (
    <>
      <FormDateInput
        name="metadata.acquisition_date"
        title={t("investment:acquisitionDate")}
      />
      <FormDateInput
        name="metadata.disposition_date"
        title={t("investment:dispositionDate")}
      />
      <InvestmentLocationFormToggle />
      <FormMoneyInput
        name="metadata.target_amount"
        title={t("investment:targetAmount")}
      />
      <RealEstateInvestmentTypeFormSelect />
    </>
  );
};

export const PortfolioAllocationMethodologyFormToggle: React.FC = () => {
  const { t } = useTranslation(["investment"]);
  return (
    <FormBooleanToggleButtonGroup
      name="metadata.is_allocable"
      title={<AllocationMethodologyTitle />}
      trueText={t("investment:portfolio")}
      falseText={t("investment:investment")}
    />
  );
};
